module.exports = __webpack_public_path__ + "img/emoji-looking-eyes-240x240.7c77f3c1.png";